<template>
  <div ref="shareMenu" class="share-menu">
    <div class="share-menu-box">
      <SocialShareButtons
        :share-url="(url as unknown as URL)"
        :share-text="url"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  url: string;
}>();

const emits = defineEmits(["close"]);

const shareMenu = ref(null);
onClickOutside(shareMenu, () => {
  emits("close");
});
</script>

<style lang="scss" scoped>
.share-menu {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, calc(-100% - 5px));
}

.share-menu-box {
  display: flex;
  gap: 0.5rem;
  flex-wrap: nowrap;

  padding: 0.5rem;
  border-radius: 0.5rem;
  position: relative;
  background: $light-100;
  border: 1px solid $light-80;
}
.share-menu-box:after,
.share-menu-box:before {
  top: 100%;
  left: 50%;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.share-menu-box:after {
  border-color: rgba($light-100, 0);
  border-top-color: $light-100;
  border-width: 5px;
  margin-left: -5px;
}
.share-menu-box:before {
  border-color: rgba($light-80, 0);
  border-top-color: $light-80;
  border-width: 6px;
  margin-left: -6px;
}
</style>
